import { render } from "./EditEmployeeRole.vue?vue&type=template&id=03501383&ts=true"
import script from "./EditEmployeeRole.vue?vue&type=script&lang=ts"
export * from "./EditEmployeeRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__